import { NavLink, Outlet } from 'react-router-dom';
import { Box, Button, Flex, Heading, Text } from '@cmaas/ui';
import { useAuth } from '../auth/AuthProvider';
import styles from './Layout.module.css';

const NAV_ITEMS = [
  { to: '/', label: 'Tenants', end: true },
  { to: '/properties', label: 'Properties' },
  { to: '/audit-log', label: 'Audit log' },
  { to: '/domain-events', label: 'Domain events' },
];

export function Layout() {
  const { user, logout } = useAuth();

  return (
    <Flex minHeight="100vh">
      <Box asChild width="220px" flexShrink="0" p="4" style={{ borderRight: '1px solid var(--gray-a5)' }}>
        <Flex asChild direction="column" height="100%">
          <nav>
            <Heading size="4" mb="5">
              CMaaS Admin
            </Heading>
            <Box asChild flexGrow="1">
              <ul className={styles.navList}>
                {NAV_ITEMS.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.end}
                      className={({ isActive }) => (isActive ? styles.navLinkActive : styles.navLink)}
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </Box>
            <Box pt="3" style={{ borderTop: '1px solid var(--gray-a5)' }}>
              <Text as="div" size="2">
                {user?.name}
              </Text>
              <Text as="div" size="1" color="gray" mb="2" style={{ wordBreak: 'break-all' }}>
                {user?.email}
              </Text>
              <Button type="button" variant="soft" size="1" onClick={() => void logout()}>
                Log out
              </Button>
            </Box>
          </nav>
        </Flex>
      </Box>
      <Box flexGrow="1" p="6" maxWidth="1000px">
        <Outlet />
      </Box>
    </Flex>
  );
}
